export interface LegacyImportStackHolder {
    releaseLegacyImportStack(): void;
}

// Modules that captured their import stack as an Error object while
// `fwk-import-stack-fix` was off (e.g. before the bundling config was installed
// on a worker). Without this, modules that finished loading before the flag
// became observable keep the Error (and the async scopes V8 pins to it) forever.
const holders: Set<LegacyImportStackHolder> = new Set();

export function trackLegacyImportStack(holder: LegacyImportStackHolder): void {
    holders.add(holder);
}

export function releaseLegacyImportStacks(): void {
    for (const holder of holders) {
        holder.releaseLegacyImportStack();
    }
    holders.clear();
}
